module.exports = __webpack_public_path__ + "img/IMG_2629_P_L_Foamcore.a7bc20e6.jpg";